/**
 * Checks if rich text HTML content has actual text content
 * @param {string | null | undefined} htmlString - The HTML string to check
 * @returns {boolean} indicating if there is actual text content (not just empty tags)
 */
function hasRichTextContent(htmlString) {
    if (!htmlString) return false;
    const textContent = htmlString.replace(/<[^>]*>/g, '').trim();
    return textContent.length > 0;
}

/**
 * Checks if a Builder text field holds something worth rendering. Editors routinely leave
 * fields as a single space rather than clearing them, which is truthy but renders blank.
 * @param {string | null | undefined} value - The field value to check
 * @returns {boolean} indicating if there is visible text
 */
function hasText(value) {
    return typeof value === 'string' ? value.trim().length > 0 : Boolean(value);
}

async function getBuilderData(graphql) {
    //Fetch Builder Pages
    const builderGraphQLQuery = await graphql(`
        {
            allBuilderModels {
                page(sort: { createdDate: 1 }, options: { cachebust: true, limit: 1000000 }) {
                    data {
                        url
                        description
                        title
                    }
                    content
                    published
                    startDate
                    endDate
                }
                landingPage(sort: { createdDate: 1 }, options: { cachebust: true, limit: 1000000 }) {
                    data {
                        title
                        description
                        pageUrl
                    }
                    endDate
                    startDate
                    content
                    published
                }
                symbol(options: { cachebust: true, limit: 1000000 }) {
                    id
                    content
                }
            }
        }
    `);
    return builderGraphQLQuery;
}

module.exports = {
    getBuilderData,
    hasRichTextContent,
    hasText,
};
